<template>
  <div class="Container">
    <div class="LogoWrap">
      <img src="@/assets/Flybit_Logo_color_column.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // isiOS: false,
      // isAndroid: false,
    };
  },
  mounted() {
    this.linkToApp();
    console.log("isAndroid", this.isAndroid);
    console.log("isiOS", this.isiOS);
  },
  methods: {
    linkToApp() {
      const userAgent = navigator.userAgent.toLowerCase();

      if (userAgent.indexOf("iphone") > -1) {
        // url = "flybit://";
        // location.href = "flybit://";
        // this.isAndroid = false;
        // this.isiOS = true;
        // if (downLoadApp) {
        //   location.href = url;
        // } else {
        //   // 앱스토어
        // }
      }
      if (userAgent.indexOf("android") > -1) {
        this.isAndroid = true;
        this.isiOS = false;
        if (downLoadApp) {
          location.href = url;
        } else {
          // 앱스토어
        }
      }
    },
    exeDeepLink() {
      url = "";
      location.href = url;
    },
    openApp() {
      clearInterval(check);
      clearTimeout(timer);

      if (document.webkitHidden || document.hidden) {
        clearTimers();
      }

      const check = setInterval(this.isHideWeb, 200);
      const timer = setTimeout(() => {
        redirectStore();
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.Container {
  .LogoWrap {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 103px);
    img {
      width: 100px;
    }
  }
}
</style>
